import { FaRegCircleCheck } from 'react-icons/fa6';

import { TbMapCheck } from 'react-icons/tb';
import { TbUsersGroup } from 'react-icons/tb';

import { FaHouseFlag } from 'react-icons/fa6';
import { FaLandmarkFlag } from 'react-icons/fa6';

import { GrGroup } from 'react-icons/gr';
import { RiSwordLine } from 'react-icons/ri';
import { LuUserRoundCheck } from 'react-icons/lu';
import { LiaUserAstronautSolid } from 'react-icons/lia';

// export const data = [
//   {
//     id: 1,
//     title: 'Пейнтбол с друзьями',
//     description:
//       'Любительские игры в пейнтбол на лесной площадке в Казани. Корпоративы и праздники',
//   },
//   {
//     id: 2,
//     title: 'Лазертаг для детей и взрослых',
//     description:
//       'Незабываемый день рождения, отдых выходного дня и другие праздники в лазертаге.',
//   },
//   {
//     id: 3,
//     title: 'Гидрабол с друзьями',
//     description: 'Утепленные крытые и открытые антуражные площадки.',
//   },
// ];
////
export const data = {
  id: 1,
  title: 'Лазертаг Пейнтбол и Гидробол в Казани для взрослых и детей',
  description:
    'Незабываемый день рождения, отдых выходного дня и другие праздники у на в клубе',
  detals: [
    {
      id: 1,
      icon: <TbMapCheck className="icon" />,
      text: '5 крутых площадок по всему городу',
    },
    {
      id: 2,
      icon: <FaHouseFlag className="icon" />,
      text: 'Утепленные крытые и открытые антуражные площадки',
    },
    {
      id: 3,
      text: 'Реалистичное боевое приключение',
      icon: <RiSwordLine className="icon" />,
    },
    {
      id: 4,
      text: 'В нашем клубе могут играть от 6 до 100 человек',
      icon: <GrGroup className="icon" />,
    },
    {
      id: 5,
      text: 'Профессиональные инструкторы',
      icon: <LiaUserAstronautSolid className="icon" />,
    },
    {
      id: 6,
      text: '15 лет проводим игры для вас',
      icon: <FaRegCircleCheck className="icon" />,
    },
  ],
};
